import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'

// Import global styles
import './styles/global.css'
import { queryClient } from './modules/queryClient'

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { initSentry } from '@/instrument.sentry'

initSentry()

const reactStrictMode = import.meta.env.VITE_NODE_ENV === 'development'

// 🏴‍☠️ Expose deployment tag on window for debugging and monitoring
declare global {
  interface Window {
    __deploy_tag?: string
  }
}

// Set deployment tag on window if available
if (import.meta.env.VITE_DEPLOYMENT_TAG) {
  window.__deploy_tag = import.meta.env.VITE_DEPLOYMENT_TAG
}

// Create a new router instance
const router = createRouter({
  routeTree,
  scrollRestoration: true,
  scrollRestorationBehavior: 'instant',
  scrollToTopSelectors: ['#main-content'],
  defaultViewTransition: true,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  const app = (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )

  root.render(
    reactStrictMode ? (
      <React.StrictMode>{app}</React.StrictMode>
    ) : (
      app
    )
  )
}
